import { any } from "prop-types";
import React, { createContext, useState, useContext } from "react";
import { useHistory } from "react-router-dom";
export function getBreadcrumbsAndTitle(menuId, pathName, title, path) {
  let getPath = [];
  if (path) {
    path.forEach((item) => getPath.push(item));
  }
  const pathTree = [
    { lable: "sale", title: "فروش", pathname: "/sale" },
    {
      lable: "customerInquiry",
      title: "درخواست جدید",
      pathname: "/customerInquiry",
    },
    {
      lable: "openSales",
      title: "فروش های درجریان",
      pathname: "/openSales",
    },
    {
      lable: "ProformaInvoice",
      title: "ثبت پیش فاکتور",
      pathname: "/ProformaInvoice",
    },
    {
      lable: "AwaitedSettelmentSales",
      title: "در انتظار تایید فاکتور",
      pathname: "/AwaitedSettelmentSales",
    },
    {
      lable: "SaleFactorFilesStep",
      title: "بارگذاری فاکتور",
      pathname: "/SaleFactorFilesStep",
    },
    { lable: "cartable", title: "کارتابل", pathname: "/cartable" },
    {
      lable: "AwaitedFactorSales",
      title: "در انتظار بارگذاری فاکتور",
      pathname: "/AwaitedFactorSales",
    },
    {
      lable: "saleFactorFilesStep",
      title: "بارگذاری فاکتور",
      pathname: "/saleFactorFilesStep",
    },
    {
      lable: "financial",
      title: "مالی",
      pathname: "/financial",
    },
    {
      lable: "WaitForSettlementByCustomer",
      title: "کیف پول",
      pathname: "/WaitForSettlementByCustomer",
    },
    {
      lable: "WaitForSettlement",
      title: "کیف پول",
      pathname: "/WaitForSettlement",
    },
    {
      lable: "search",
      title: "جستجو",
      pathname: "/search",
    },
    {
      lable: "searchSalefilesTable",
      title: "پرونده های فروش",
      pathname: "/searchSalefilesTable",
    },
  ];
  const result = {
    breadcrumbs: [],
    title: "",
  };
  const splitPath = pathName.split("/");
  let breadcrumbsResult = [];
  splitPath.forEach((element) => {
    let breadcrumbsTemp = pathTree.find((x) => x.lable == element);

    if (breadcrumbsTemp) {
      breadcrumbsResult.push(breadcrumbsTemp);
    }
  });

  result.breadcrumbs = breadcrumbsResult;
  return result;
}

export function getTitle(breadCrumbs, pathname) {
  if (!breadCrumbs || !pathname) {
    return "";
  }

  const length = breadCrumbs.length;
  if (!length) {
    return "";
  }

  return breadCrumbs[length - 1].title;
}

const SubheaderContext = createContext();

export function useSubheader() {
  return useContext(SubheaderContext);
}

export const SubheaderConsumer = SubheaderContext.Consumer;

export function MetronicSubheaderProvider({ children }) {
  const [title, setTitle] = useState("");
  const [breadcrumbs, setBreadcrumbs] = useState([]);
  const value = { title, setTitle, breadcrumbs, setBreadcrumbs };
  return (
    <SubheaderContext.Provider value={value}>
      {children}
    </SubheaderContext.Provider>
  );
}
